import React from 'react'
import { CardTitle } from './card'
import { cn } from '../../lib/utils'

export const CardTitleBrand = React.forwardRef<
  HTMLParagraphElement,
  React.HTMLAttributes<HTMLHeadingElement>
>(({ className, ...props }, ref) => (
  <CardTitle
    {...props}
    className={cn(className, 'text-md font-bold')}
    ref={ref}
  />
))
